export enum SearchTimeSpan {
  Today = 0,
  Yesterday = 1,
  Last7Days = 2,
  Last30Days = 3,
  ThisQuarter = 4,
  PreviousQuarter = 5,
  ThisYear = 6,
  PreviousYear = 7  
}